import React, { createContext, useContext, useEffect, useState } from "react";
import logger from "../lib/logger";
import { adminApi } from "./adminApi";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const me = await adminApi.me();
                setAdmin(me);
            } catch (err) {
                if (err?.response?.status !== 401) {
                    logger.warn("admin /me failed:", err);
                }
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const login = async (email, password) => {
        const data = await adminApi.login(email, password);
        setAdmin(data.admin);
        return data.admin;
    };

    const logout = async () => {
        try { await adminApi.logout(); } catch (err) { logger.warn("logout request failed:", err); }
        setAdmin(null);
    };

    return (
        <AdminAuthContext.Provider value={{ admin, loading, login, logout }}>
            {children}
        </AdminAuthContext.Provider>
    );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
